import React, { useState } from "react";
import Tooltip from "../../../../Elements/Tooltip/Tooltip.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import { LinkToNewTab } from "../../../../Elements/Link/Link.js";
import PickerFormLimitActionsModal from "../Modals/PickerFormLimitActionsModal.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useToasts } from "react-toast-notifications";

const HeaderItem = ({
  i,
  openScript,
  setOpenScript,
  form,
  item,
  isFocus,
  setIsFocus,
}) => {
  const { getTextByKey } = useContent();
  const { addToast } = useToasts();
  const { setModal } = useModal();
  const [activeIcon, setActiveIcon] = useState("");
  const clickHandle = () => {
    item.itemFunction && item.itemFunction();
    if (item.itemName === "code") {
      activeIcon === item.itemName + i
        ? setActiveIcon("")
        : setActiveIcon(item.itemName + i);
      openScript !== i ? setOpenScript(i) : setOpenScript(null);
    }
  };

  const enterButtonFunction = (e) => {
    if (e.key === "Enter") {
      clickHandle();
    }
  };

  const editPickerForm = () => {
    addToast(getTextByKey("picker-form-actions-modal-text"), {
      appearance: "error",
    });
  };

  return (
    <li
      tabIndex={0}
      onKeyDown={(e) => enterButtonFunction(e)}
      onFocus={() => setIsFocus(true)}
      onBlur={() => setIsFocus(false)}
      onClick={() => {
        clickHandle();
      }}
    >
      {item.itemName === "list" ? (
        <LinkToNewTab
          isNewTab
          page={`user/jumbo-forms/activity-reports/${form.Embed_Dynamic_Id}`}
        >
          <Tooltip
            id={item.itemName}
            tooltipTextKey={item.tooltipTextKey}
            //hardPositioned
          >
            <Icon
              //iconClass={activeIcon === "list" + i ? "active" : ""}
              name={item.iconName}
            />
          </Tooltip>
        </LinkToNewTab>
      ) : item.itemName === "pencil" ? (
        form.IsPickerForm ? (
          <div className="edit-picker-form" onClick={() => editPickerForm()}>
            <Tooltip
              id={item.itemName}
              tooltipTextKey={item.tooltipTextKey}
              //hardPositioned
            >
              <Icon
                //iconClass={activeIcon === item.itemName + i ? "active" : ""}
                name={item.iconName}
              />
            </Tooltip>
          </div>
        ) : (
          <LinkToNewTab
            isNewTab={true}
            page={`create-form/${form.Embed_Dynamic_Id}`}
          >
            <Tooltip
              id={item.itemName}
              tooltipTextKey={item.tooltipTextKey}
              //hardPositioned
            >
              <Icon
                //iconClass={activeIcon === item.itemName + i ? "active" : ""}
                name={item.iconName}
              />
            </Tooltip>
          </LinkToNewTab>
        )
      ) : (
        <Tooltip
          tabIndex={0}
          id={item.itemName}
          tooltipTextKey={item.tooltipTextKey}
          //hardPositioned
        >
          <Icon
            //iconClass={activeIcon === item.itemName + i ? "active" : ""}
            name={item.iconName}
          />
        </Tooltip>
      )}
    </li>
  );
};

export default HeaderItem;
